import React from 'react';
import {useNavigate} from 'react-router-dom';
import Table from '../Table';
import Spinner from '../Spinner';

const HEAD_CELLS = [
  {id: 'customer', numeric: false, disabledPadding: true, label: 'Customer'},
  {id: 'flatNumber', numeric: false, disabledPadding: false, label: 'Flat'},
  {id: 'buildingName', numeric: false, disabledPadding: false, label: 'Project'},
  {id: 'entranceName', numeric: false, disabledPadding: false, label: 'Entrance'},
  {id: 'garageName', numeric: false, disabledPadding: false, label: 'Garages'},
  {
    id: 'garageEntrances',
    numeric: false,
    disabledPadding: false,
    label: 'Garage entrances',
  },
  {id: 'siteCode', numeric: false, disabledPadding: false, label: 'Site code'},
  {id: 'converted', numeric: false, disabledPadding: false, label: 'Converted'},
  {id: 'siteNumber', numeric: false, disabledPadding: false, label: 'Site number'},
  {id: 'carPlates', numeric: false, disabledPadding: false, label: 'Car plates'},
  {id: 'createdAt', numeric: false, disabledPadding: true, label: 'Created at'},
];

const DATA_CELLS = HEAD_CELLS.map(c => c.id);

// Clicking a row jumps to the customer so the data can be edited there.
const GarageReportTable = ({rows, loading}) => {
  const navigate = useNavigate();

  if (loading) {
    return <Spinner />;
  }

  return (
    <Table
      data={rows}
      tableName="Garages"
      headCells={HEAD_CELLS}
      dataCells={DATA_CELLS}
      onRowClick={row => row.customerId && navigate(`/customers/${row.customerId}`)}
      rowHref={row => (row.customerId ? `/customers/${row.customerId}` : null)}
      getObject
      noSort
      noFilter
    />
  );
};

export default GarageReportTable;
